import { formatRelative } from "@veil/ui/lib/format";
import type { ClusterStats } from "./types";

/**
 * Single-line dirty metric for the cockpit command bar. The status colour
 * accent is applied by the bar itself; this just owns the text. The global
 * site-header already shows a separate "Cluster dirty" pill.
 */
export function DirtyBadge({ stats }: { stats: ClusterStats | undefined }) {
	const dirty = stats?.dirty === true;
	const last = stats?.lastRender?.finishedAt;
	if (dirty) {
		return (
			<span title="The live nginx.conf is older than the most recent edit.">
				Unrendered changes
				{last ? ` · last render ${formatRelative(last)}` : " · no render yet"}
			</span>
		);
	}
	return (
		<span title="Live nginx.conf matches the database.">
			In sync
			{last ? ` · rendered ${formatRelative(last)}` : ""}
		</span>
	);
}
